<template>
	<div 
		class="text-input"
		:class="[
			darkMode ? 'dark-mode' : '',
			noMargin ? 'no-margin' : '',
			isError ? 'is-error' : ''
		]"
		>
		<label>{{ label }}</label>
		<input  
			:value="modelValue" 
			:type="type"
			@input="$emit('update:modelValue', $event.target.value)" 
			ref="input"
			:autocomplete="autocomplete"
			:placeholder="placeholder"
			:disabled="disabled"
			:min="minValue"
			@keyup="$emit('keyup', $event.target.value)"
			/>
	</div>
</template>

<script>
	export default {
		props: {
			label: {
				type: String,
				required: true
			},
			type: {
				type: String,
				required: true
			},
			modelValue: {
				type: [String, Boolean, Number],
				required: false
			},
			autocomplete: {
				type: String,
				default: 'off'
			},
			darkMode: {
				type: Boolean,
				default: false
			},
			noMargin: {
				type: Boolean,
				default: false
			},
			placeholder: {
				type: String,
				default: ''
			},
			disabled: {
				type: Boolean,
				default: false
			},
			isError: {
				type: Boolean,
				default: false
			},
			minValue: {
				type: Number,
				default: 0
			},
		},
		emits: ['update:modelValue'],
		methods: {
			focus() {
				this.$refs.input.focus()
			}
		}
	}
</script>

<style lang="sass" scoped>

.text-input
	margin: 0 0 30px
	display: flex
	flex-direction: column
	width: 100%
	// max-width: 30rem
	
	label
		font-family: 'Roboto Condensed', sans-serif
		font-weight: 700
		font-size: 16px
		line-height: 1.1
		color: #252525
		margin-bottom: 10px

	input
		border-radius: 3px
		border: 1px solid lighten(#111, 70%)
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05)

		&:disabled
			background-color: lighten(#111, 90%)
			color: lighten(#111, 70%)
			cursor: not-allowed

	&.dark-mode
		label
			color: rgba(#fff, 0.7)

		input
			background-color: rgba(#fff,0.2)
			color: #fff

			&::placeholder
				color: rgba(#fff,0.6)

	&.no-margin
		margin: 0

	&.is-error
		input
			border-color: #ff0000
			background-color: rgba(#ff0000, 0.02)
			color: #ff0000

			&::placeholder
				color: rgba(#ff0000, 0.6)


</style>

